import {
  PageContainer,
  labelDefaultMediumStyles,
  labelDefaultRegularStyles,
  labelLargeMediumStyles
} from '@lifebit-ai/lds'
import styled from 'styled-components'

export const UserSettingsAvatar = styled.div`
  ${labelDefaultMediumStyles};
  align-items: center;
  background: ${({ theme }) => theme.color.base.yellow[40]};
  border-radius: ${({ theme }) => theme.size.space['025']};
  color: ${({ theme }) => theme.color.background.contrast};
  display: flex;
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  height: 24px;
  justify-content: center;
  text-transform: uppercase;
  width: 24px;
`

export const UserSettingsLargeAvatar = styled(UserSettingsAvatar)`
  width: 36px;
  height: 36px;
`

export const UserSettingsPopoverContainer = styled(PageContainer)`
  background-color: ${({ theme }) => theme.color.background.main};
  border-radius: 12px;
  border-radius: unset;
  box-shadow: unset;
  flex-direction: column;
  padding: 0;
  width: 242px;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['04']};
  padding: ${({ theme }) => theme.size.space['05']};
  cursor: default;
`

export const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.size.space['01']};
`

export const UserName = styled.div`
  color: ${({ theme }) => theme.color.content.main};
  word-break: break-all;
  ${labelLargeMediumStyles};
`

export const UserEmail = styled.div`
  color: ${({ theme }) => theme.color.content.secondary};
  word-break: break-all;
  ${labelDefaultRegularStyles};
`

export const ManageAccountContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.size.space['05']};
  border-bottom: 1px solid ${({ theme }) => theme.color.border.subtle};
  ${labelDefaultRegularStyles}
`

export const ManageAccountText = styled.div`
  ${labelDefaultRegularStyles}
`

export const LogoutContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.size.space['05']};
`

export const LogoutText = styled.div`
  ${labelDefaultRegularStyles}
`
